export default __webpack_public_path__ + "static/media/front_page.4027be23.jpg";